// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Jlt5","col":"styles_col__1FsSy"};